/**
 * Header.
 */

const header = (args) => {
    // setup args
    let header = args.header;
    let debounceTimeout;
    const debounceDelay = 100;
    const defaultHeaderHeight = 144;

    // validate
    if (!header) {
        // console.log('Invalid args');
        return;
    }

    function init() {
        H_Tools?.header?.setHeaderHeight(defaultHeaderHeight);
        H_Tools?.header?.setHeaderHeight(header.clientHeight);

        new ResizeObserver((entries) => {
            clearTimeout(debounceTimeout);
            debounceTimeout = setTimeout(() => {
                const { height } = entries[entries.length - 1].contentRect;
                H_Tools?.header?.setHeaderHeight(height);
            }, debounceDelay);
        }).observe(header);
    }

    init();

    return this;
};

header({
    header: document.querySelector('.js-site-header'),
});
